import { graphql } from "@/gql";

export const ENABLED_INCIDENT_TYPES_QUERY = graphql(`
  query ENABLED_INCIDENT_TYPES_QUERY($organizationId: String!) {
    enabledIncidentTypes(condition: { organizationId: $organizationId }) {
      totalCount
      nodes {
        id
        defaultAssignedGroup {
          id
          name
        }
        incidentType {
          id
          category
          name
          description
          iconSvg
          uiSchema
          dataSchema
        }
      }
    }
    organization(id: $organizationId) {
      id
      members {
        nodes {
          id
          fullName
          displayName
          isEnabled
        }
      }
    }
  }
`);
